import { render, staticRenderFns } from "./LocalesView.vue?vue&type=template&id=8b06e5d8&"
import script from "./LocalesView.vue?vue&type=script&lang=ts&"
export * from "./LocalesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports